import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParagraph: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconParagraph"><Path d="M20.5 3.5H15.5M9.5 12.5H7.75C5.26472 12.5 3.25 10.4853 3.25 8C3.25 5.51472 5.26472 3.5 7.75 3.5H9.5M9.5 12.5V20.5M9.5 12.5V3.5M9.5 3.5H15.5M15.5 3.5V20.5775" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconParagraph;
